import {
  Box,
  Button,
  Pagination,
  Paper,
  Slide,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import React, { Dispatch, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { SwSnackbar } from '../../commonComponent/views/SwSnackbar';
import { getUserList } from '../../../common/api/ApiUser';
import { KEY_USER_LIST } from '../../../common/key';
import { TableTitle } from '../../commonComponent/tableElement/TableTitle';
import {
  convertIphoneModel,
  getGender,
  removeNatCodePhoneNumber,
  timestamp2Localestring,
} from '../../../common/helper';

interface Props {
  columns: any[];
  rows: any[];
  totalCount: number;
  rowsPerPage: number;
  searchData: string[];
  onAddEmail: () => void;
  setUserData: Dispatch<React.SetStateAction<any>>;
  isOpenUserDetail: () => void;
}

export const UserInquireTable: React.FC<Props> = ({
  columns,
  rows,
  totalCount,
  rowsPerPage,
  searchData,
  onAddEmail,
  setUserData,
  isOpenUserDetail,
}) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const containerRef = useRef<any>();
  const [open, setopen] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [openSnakerDialog, setOpenSnakerDialog] = useState<boolean>(false);
  const handleChangePage = (_event: any, newPage: number) => {
    setPage(newPage);
    queryClient.prefetchQuery(KEY_USER_LIST, () =>
      getUserList(newPage, rowsPerPage, searchData[0], searchData[1])
    );
  };

  useEffect(() => {
    console.log('searwchData:', searchData);
  }, []);

  return (
    <Paper sx={{ p: '1.5rem', m: '1.4rem 0' }}>
      <TableTitle title='조회된 계정' count={totalCount} />
      <TableContainer>
        <Table sx={{ whiteSpace: 'nowrap' }}>
          <TableHead>
            <TableRow>
              {columns.map((column, idx) => (
                <TableCell
                  key={idx.toString()}
                  sx={{ fontSize: '.88rem', fontWeight: 400, p: '.5rem' }}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .map(row => [
                row.nickname == null ? '-' : row.nickname,
                row.uid == null ? '-' : row.uid,
                row.email == null ? '-' : row.email,
                row.memberCode == null ? '-' : row.memberCode,
                row.schoolName == null ? '-' : row.schoolName,
                row.schoolGrade == null
                  ? '-'
                  : `${row.schoolGrade}학년 ${row.schoolClass}반`,
                row.memberNumber == null ? '-' : row.memberNumber,
                getGender(row.gender),
                row.createDate === null
                  ? '-'
                  : timestamp2Localestring(row.createDate, 1000),
                row.appVersion === null || row.appVersion === undefined
                  ? '-'
                  : row.appVersion,
                row.memberTypeCd === null
                  ? '미연동'
                  : row.memberTypeCd === 'GOOGLE'
                  ? '헬스커넥트'
                  : row.memberTypeCd === 'APPLE'
                  ? '건강(헬스킷)'
                  : '미연동',
              ])
              .map((value: any, idx) => (
                <TableRow key={idx.toString()}>
                  {value.map((w: any, i: number) => (
                    <TableCell
                      key={i.toString()}
                      className={
                        rows[idx].auth === 0 ? 'not_important_row' : ''
                      }
                    >
                      {w}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ p: '.6rem', display: 'flex', justifyContent: 'center' }}>
        <Pagination
          color='primary'
          variant='outlined'
          page={page}
          onChange={handleChangePage}
          count={Math.ceil(totalCount / rowsPerPage)}
        />
      </Box>
      <SwSnackbar
        open={openSnakerDialog}
        onClose={() => setOpenSnakerDialog(false)}
        contents={snackbarMessage}
      />
    </Paper>
  );
};
